import cx from 'classnames';
import { Button, IButtonProps } from 'components/admin/ui';
import { FilterLines } from 'ethena-icons';
import { forwardRef } from 'react';
import css from './FiltersButton.module.scss';

interface IFiltersButtonProps extends IButtonProps {
  numActiveFilters?: number;
}

export const FiltersButton = forwardRef<HTMLButtonElement, IFiltersButtonProps>(
  ({ numActiveFilters, className, ...rest }, ref) => (
    <Button
      color="black"
      className={cx(css.button, className)}
      ref={ref}
      variant="outline-light"
      {...rest}
    >
      <FilterLines height={14} width={14} className={css.icon} />
      Filters{numActiveFilters > 0 && ` (${numActiveFilters})`}
    </Button>
  )
);

FiltersButton.displayName = 'FiltersButton';
